<template>
    <!-- This uses copies the structure for sessions info from cart.html -->
    <div data-component="sessionDateTimeLine"
         class="session-date-time-line">
        <template v-if="!session.multiDay">
            <!-- Session date -->
            {{ dateFilter(session.startTime) }}

            <!-- Session start time -->
            <i class="fa-solid fa-clock fa-fw"></i>
            {{ timeFilter(session.startTime) }}

            <!-- Session end time -->
            <span v-if="session.endTime != null">
                <i class="fa-solid fa-circle-arrow-right"></i>
                {{ timeFilter(session.endTime) }}
            </span>
        </template>

        <template v-if="session.multiDay">
            <!-- Multi-day session start date -->
            <i class="fa-solid fa-calendar"></i>
            {{ dateFilter(session.startTime) }}
            {{ timeFilter(session.startTime) }}

            <!-- Multi-day session end date -->
            <i class="fa-solid fa-circle-arrow-right"></i>
            {{ dateFilter(session.endTime) }}
            {{ timeFilter(session.endTime) }}
        </template>
    </div>
</template>

<script>
export default {
    props: {
        session: {
            type: Object,
            required: true,
        },
    },

    created() {
        console.log(this.session);
    },
};
</script>

<style lang="less">
    @import "../../../../less/variables.less";
    .session-date-time-line {
        flex-grow: 0;
        flex-shrink: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: @font-size-medium;
    }
</style>
